define('../cloud-pro/js/xray',['require','exports','module','../../common/js/xray','../../cloud-mobile/js/store'],function(require, exports, module) {
    var sendDwh = require('../../common/js/xray');
    var store = require('../../cloud-mobile/js/store');

    var defaultParams = function() {
        var clientId = store.get('clientId');
        var email = null;

        if (window.__PH) {
            email = window.__PH.activeUser();
        }

        return {
            client_id: clientId,
            email: email
        };
    };

    var sendProXray = function(label, tariff) {
        var dwhParams = defaultParams();

        if (tariff) {
            dwhParams.name_tariff = tariff;
        }

        sendDwh('landing_pro', '', label, '', dwhParams);
    };

    module.exports = {
        sendProXray: sendProXray,
        defaultParams: defaultParams
    };
});

